 
import AWS, { KinesisVideo, KinesisVideoArchivedMedia } from 'aws-sdk';

const REGION = process.env.REACT_APP_KINESIS_REGION;
const ACCESS_KEY = process.env.REACT_APP_KINESIS_ACCESS_KEY_ID;
const SECRET_KEY = process.env.REACT_APP_KINESIS_SECRET_ACCESS_KEY;

AWS.config.update({
  region: REGION,
  accessKeyId: ACCESS_KEY,
  secretAccessKey: SECRET_KEY,
});

export const getKinesisStreamURL = async (STREAM_NAME = process.env.REACT_APP_KINESIS_STREAM_NAME) => {
  const kinesisVideo = new KinesisVideo();
  kinesisVideo.config.update({ region: REGION });

  // eslint-disable-next-line no-useless-catch
  try {
    const data = await kinesisVideo.getDataEndpoint({
      StreamName: STREAM_NAME,
      APIName: 'GET_HLS_STREAMING_SESSION_URL',
    }).promise();

    const kinesisVideoArchivedMedia = new KinesisVideoArchivedMedia({
      endpoint: data.DataEndpoint,
    });

    const hlsStream = await kinesisVideoArchivedMedia.getHLSStreamingSessionURL({
      StreamName: STREAM_NAME,
      PlaybackMode: 'LIVE',
    }).promise();

    return hlsStream.HLSStreamingSessionURL;
  } catch (error) {
    throw error;
  }
};
